import { Component } from '@angular/core';
import { NonIPBoardSummaryComponent } from '../non-ip-board-summary.component';

@Component({
  selector: 'client-other-product-summary',
  templateUrl: './client-other-product-summary.component.html',
  styleUrls: ['./client-other-product-summary.component.scss']
})
export class ClientOtherProductSummaryComponent extends NonIPBoardSummaryComponent {}
